import { LoyaltyMinTierPoints, LoyaltyTier } from '@montugroup/contracts-warehousing-api';

/**
 * Map out the loyalty tiers and their minimum points required to achieve them
 */
export const loyaltyTiers: { tier: LoyaltyTier; minPoints: number }[] = [
  { tier: LoyaltyTier.None, minPoints: LoyaltyMinTierPoints.None },
  { tier: LoyaltyTier.Bronze, minPoints: LoyaltyMinTierPoints.Bronze },
  { tier: LoyaltyTier.Silver, minPoints: LoyaltyMinTierPoints.Silver },
  { tier: LoyaltyTier.Gold, minPoints: LoyaltyMinTierPoints.Gold },
  { tier: LoyaltyTier.Platinum, minPoints: LoyaltyMinTierPoints.Platinum },
];

/**
 * The percentage of the progress bar that is dedicated to the none tier segment in the Loyalty progress bar
 * (e.g. the distance between the start and the first tier circle).
 *
 * This is needed since the width of the none tier segment is not the same as the other tiers.
 */
export const INITIAL_TIER_SEGMENT_SIZE = 10;

export const LOYALTY_LOGO_IMG_SRC = '/leafio-loyalty-logo.png';

export const LOYALTY_TRANSACTIONS_TABLE_ROWS_PER_PAGE = 16;
export const LOYALTY_TRANSACTIONS_CYCLE_DAYS = 90;
